import { PureComponent } from 'react';

import FormErrorMessage from 'components/FormErrorMessage';
import { FormInput } from 'components/FormInput/FormInput';
import PropTypes from 'prop-types';

export default class TitleWidget extends PureComponent {
  static propTypes = {
    input: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    msg: PropTypes.object.isRequired,
  };

  handleNameChange = ({ target: { value } }) => {
    this.props.input.onChange(value);
  };

  render() {
    const {
      meta: { touched, error },
      msg,
      input,
    } = this.props;
    return (
      <div>
        <FormInput
          autoFocus
          className='form-control dashboard-color-form__title-widget-input'
          hasError={touched && error && error === 'requiredName'}
          name={input.name}
          onChange={this.handleNameChange}
          value={input.value}
        />
        {touched && error ? (
          <FormErrorMessage>{msg.validation[error]}</FormErrorMessage>
        ) : null}
      </div>
    );
  }
}
